import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../components/Button';

export type ViewMode = 'value' | 'quantity';

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="btn-group" role="group">
      <Button
        text={t('dashboard.pageTexts.filter.viewMode.value')}
        className={`btn btn-sm ${value === 'value' ? 'btn-primary' : 'btn-outline-primary'}`}
        onClick={() => onChange('value')}
      />
      <Button
        text={t('dashboard.pageTexts.filter.viewMode.quantity')}
        className={`btn btn-sm ${value === 'quantity' ? 'btn-primary' : 'btn-outline-primary'}`}
        onClick={() => onChange('quantity')}
      />
    </div>
  );
};

export default ViewModeToggle;
